import { Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { themeConWeb } from '../../util/modernThemeConweb'

const useStyles = makeStyles({
  root: {
    color: props => props.color,
    fontSize: '14px',
    fontWeight: 'bold',
  },
})

/**
 * A button component that looks like a Link
 */
const LinkButton = ({ children, color = themeConWeb.color.black, ...rest }) => {
  const classes = useStyles({ color })
  return (
    <Link className={classes.root} component="button" {...rest}>
      {children}
    </Link>
  )
}

export default LinkButton
